<div class=" custom-class">
  <div class="modal-body">
    <div class="">
      <div class="d-flex justify-content-between align-items-center" *ngIf="slideConfig">
        <button class="btn"  style="border-width: 4pt" [style.border-color]="'#353635'"  [style.background-color]="'#353635'"><</button>
        <ngx-slick-carousel
          [config]="{ slidesToShow: 5, slidesToScroll: 1 ,currentSlide: 1}"
          class="carousel"
          #slickModal="slick-carousel"
          style="background-color: #1D1D1B;"
          (afterChange)="afterChange($event)"

        >
<!--          <div ngxSlickItem *ngFor="let slide of slides" class="slide">-->
<!--            <img src="{{ slide.img }}" alt="" width="100%">-->
<!--          </div>-->
          <div ngxSlickItem *ngFor="let slide of slides" class="slide">
            <button class="btn articolo"  style="border-width: 4pt" [style.border-color]="'#353635'"  [style.background-color]="'#353635'">Articolo n.3</button>
          </div>
        </ngx-slick-carousel>

<!--        <button (click)="addSlide()">Add</button>-->
<!--        <button (click)="removeSlide()">Remove</button>-->
<!--        <button (click)="slickModal.slickGoTo(2)">slickGoto 2</button>-->
<!--        <button (click)="slickModal.unslick()">unslick</button>-->
        <button class="btn"  style="border-width: 4pt" [style.border-color]="'#353635'"  [style.background-color]="'#353635'">></button>
      </div>
      <div class="row">

      </div>
    </div>
  </div>
</div>
